import { render } from "./ClientServiceQuarantineDurationDialog.vue?vue&type=template&id=5b16ea5a"
import script from "./ClientServiceQuarantineDurationDialog.vue?vue&type=script&lang=js"
export * from "./ClientServiceQuarantineDurationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__